import {ExclamationCircleIcon, XIcon} from '@heroicons/react/outline';

import Spinner from '@/assets/svg/Spinner';
import Receipt from '@/components/Receipt';
import type {AdminAfriexPerson} from '@/types';

import {useKYCReceipt} from './useKYCReceipt';

const KycReceipt = ({data}: {data: AdminAfriexPerson}) => {
  const {images, setImages, imagesLoading} = useKYCReceipt(data);
  if (imagesLoading) {
    return <Spinner size={8} className="text-cyan-600" />;
  }

  if (images.length === 0) {
    return (
      <div className="main flex flex-col bg-receipt-bg p-5 mt-5 gap-4 text-cyan-600">
        No KYC documents
      </div>
    );
  }

  const removeImage = (id: string) => {
    setImages((prevImages) => prevImages.filter((img) => img.id !== id));
  };

  return (
    <div className="flex flex-col">
      <p className="flex font-sm gap-2 justify-center text-gray-600 bg-yellow-100 p-2 rounded-md">
        <ExclamationCircleIcon className="w-6 h-6 text-orange-500" />
        {"You can now remove images you don't want to print"}
      </p>

      <Receipt type="kyc" scope={data.id}>
        <div className="main flex flex-col bg-receipt-bg dark:bg-gray-900 p-5 mt-5 gap-4">
          {images.map((image) => (
            <div key={image.id} className="relative">
              {image.url && (
                <img
                  src={image.url}
                  alt={`${image.source}`}
                  className="w-full h-auto"
                  crossOrigin="anonymous"
                />
              )}
              {/* Remove Button */}
              <div
                onClick={() => removeImage(image.id)}
                className="absolute top-2 right-2 p-0 font-sm no-print bg-red-500 rounded-full cursor-pointer"
                data-html2canvas-ignore
              >
                <XIcon className="w-6 h-6 text-white" />
              </div>
            </div>
          ))}
        </div>
      </Receipt>
    </div>
  );
};

export default KycReceipt;
